// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../selection/SelectionModals.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-modal__body {
  padding: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.import-modal__step-label {
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-1);
}

.import-modal__source-select {
  display: flex;
  gap: var(--space-3);
}

.import-modal__source-btn {
  flex: 1;
  padding: var(--space-3) var(--space-4);
  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-parchment-100);
  cursor: pointer;
  transition: all var(--transition-fast);
  text-align: center;
}

.import-modal__source-btn:hover {
  border-color: var(--color-fire-400);
  background: var(--color-wood-800);
}

.import-modal__source-btn--active {
  border-color: var(--color-fire-500);
  background: var(--color-fire-600);
  color: white;
  box-shadow: 0 2px 8px rgba(216, 90, 31, 0.35);
}

.import-modal__url-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.import-modal__url-input {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  background: var(--color-parchment-200);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  font-size: 14px;
  font-family: var(--font-body);
  color: var(--color-text-primary);
  transition: border-color var(--transition-fast);
  box-sizing: border-box;
}

.import-modal__url-input:focus {
  outline: none;
  border-color: var(--color-fire-500);
}

.import-modal__url-input::placeholder {
  color: var(--color-text-tertiary);
}

.import-modal__url-hint {
  font-size: 12px;
  color: var(--color-text-tertiary);
}

.import-modal__actions {
  display: flex;
  gap: var(--space-3);
  padding-top: var(--space-2);
}

.import-modal__submit {
  flex: 1;
  padding: var(--space-3) var(--space-5);
  background: var(--color-fire-500);
  border: none;
  border-radius: var(--radius-lg);
  color: white;
  font-family: var(--font-heading);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.import-modal__submit:hover:not(:disabled) {
  background: var(--color-fire-600);
}

.import-modal__submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.import-modal__cancel {
  padding: var(--space-3) var(--space-5);
  background: var(--color-parchment-200);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  color: var(--color-text-primary);
  font-family: var(--font-heading);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.import-modal__cancel:hover {
  background: var(--color-parchment-300);
}

.import-modal__error {
  color: var(--color-danger-500);
  font-size: 13px;
  padding: var(--space-2) var(--space-3);
  background: rgba(168, 52, 42, 0.08);
  border-radius: var(--radius-md);
}

.import-modal__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-5);
  color: var(--color-text-secondary);
  font-size: 14px;
}

.import-modal__spinner {
  width: 20px;
  height: 20px;
  border: 3px solid var(--color-parchment-300);
  border-top-color: var(--color-fire-500);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/ImportGameModal.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,sCAAsC;EACtC,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,uCAAuC;EACvC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["@import '../../features/selection/SelectionModals.css';\n\n.import-modal__body {\n  padding: var(--space-5);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.import-modal__step-label {\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-1);\n}\n\n.import-modal__source-select {\n  display: flex;\n  gap: var(--space-3);\n}\n\n.import-modal__source-btn {\n  flex: 1;\n  padding: var(--space-3) var(--space-4);\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-parchment-100);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-align: center;\n}\n\n.import-modal__source-btn:hover {\n  border-color: var(--color-fire-400);\n  background: var(--color-wood-800);\n}\n\n.import-modal__source-btn--active {\n  border-color: var(--color-fire-500);\n  background: var(--color-fire-600);\n  color: white;\n  box-shadow: 0 2px 8px rgba(216, 90, 31, 0.35);\n}\n\n.import-modal__url-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.import-modal__url-input {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  background: var(--color-parchment-200);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  font-size: 14px;\n  font-family: var(--font-body);\n  color: var(--color-text-primary);\n  transition: border-color var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.import-modal__url-input:focus {\n  outline: none;\n  border-color: var(--color-fire-500);\n}\n\n.import-modal__url-input::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.import-modal__url-hint {\n  font-size: 12px;\n  color: var(--color-text-tertiary);\n}\n\n.import-modal__actions {\n  display: flex;\n  gap: var(--space-3);\n  padding-top: var(--space-2);\n}\n\n.import-modal__submit {\n  flex: 1;\n  padding: var(--space-3) var(--space-5);\n  background: var(--color-fire-500);\n  border: none;\n  border-radius: var(--radius-lg);\n  color: white;\n  font-family: var(--font-heading);\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.import-modal__submit:hover:not(:disabled) {\n  background: var(--color-fire-600);\n}\n\n.import-modal__submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.import-modal__cancel {\n  padding: var(--space-3) var(--space-5);\n  background: var(--color-parchment-200);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  color: var(--color-text-primary);\n  font-family: var(--font-heading);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.import-modal__cancel:hover {\n  background: var(--color-parchment-300);\n}\n\n.import-modal__error {\n  color: var(--color-danger-500);\n  font-size: 13px;\n  padding: var(--space-2) var(--space-3);\n  background: rgba(168, 52, 42, 0.08);\n  border-radius: var(--radius-md);\n}\n\n.import-modal__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3);\n  padding: var(--space-5);\n  color: var(--color-text-secondary);\n  font-size: 14px;\n}\n\n.import-modal__spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid var(--color-parchment-300);\n  border-top-color: var(--color-fire-500);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
